module.exports = __webpack_public_path__ + "static/media/account_list_black.71daaf01.svg";